import React from 'react'
import { AuthRoute, NotFound, Redirect, Route, Switch, useLocation } from '@fs/zion-router'
import ErrorBoundary from '@fs/zion-error-boundary'
import { GenericErrorView } from './shared/components/GenericErrorView'
import FeedbackButton from './shared/components/FeedbackButton/FeedbackButton'
import { APP_PATHS, EVENT_ID_PATTERN, isTemplePath } from './shared/config'

const ContactsPage = React.lazy(() => import('./pages/ContactsPage'))
const AdminRouter = React.lazy(() => import('./AdminRouter'))
const FamousPersonRouter = React.lazy(() => import('./pages/FamousPersonPage/FamousPersonRouter'))
const EventRouter = React.lazy(() => import('./EventRouter'))
const TempleRouter = React.lazy(() => import('./pages/TemplePage'))
const QaPanel = React.lazy(() => import('./shared/qa/QaPanel'))

const eventIdRegex = new RegExp(EVENT_ID_PATTERN)

function App(): JSX.Element {
  const location = useLocation()

  // Temple paths hold no event id, and TempleRouter serves its own EventFeedbackButton, so they count as event routes.
  const isEventRoute = eventIdRegex.test(location.pathname) || isTemplePath(location.pathname)

  return (
    <ErrorBoundary FallbackComponent={GenericErrorView}>
      <Switch>
        <AuthRoute path={APP_PATHS.contacts}>
          <ContactsPage />
        </AuthRoute>
        {/* Legacy path. It is not in APP_PATHS, because the middleware exempts every APP_PATHS entry. */}
        <Route path="/groups/contacts">
          <Redirect to={APP_PATHS.contacts} />
        </Route>

        <Route path={APP_PATHS.famous} component={FamousPersonRouter} />

        <AuthRoute path={APP_PATHS.admin}>
          <AdminRouter />
        </AuthRoute>

        <Route path={APP_PATHS.temple} component={TempleRouter} />

        <Route path="/:eventId" component={EventRouter} />

        <Route component={NotFound} />
      </Switch>
      {!isEventRoute && <FeedbackButton />}
      <React.Suspense fallback={null}>
        <QaPanel />
      </React.Suspense>
    </ErrorBoundary>
  )
}
export default App
